import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ExportExcelSupervisorTrackingTicketDto,
  ExportExcelTicketRequestDto,
  ExportExcelUsersDto,
  RequestData,
  ResponseDto
} from 'types';
import axiosBaseQuery from 'utils/base-api';

export const excelsApi = createApi({
  reducerPath: 'excelsApi',
  tagTypes: [],
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    exportUsers: builder.mutation<Pick<ResponseDto<null>, 'statusCode' | 'message'>, ExportExcelUsersDto>({
      query: (data) => ({
        url: '/excels/export_users',
        method: 'post',
        data: data
      })
    }),

    exportTickets: builder.mutation<Pick<ResponseDto<null>, 'statusCode' | 'message'>, ExportExcelTicketRequestDto | RequestData >({
      query: (data) => {
        const cleanedData = cleanObject(data);

        return {
          url: `/excels/export_${data.status}_tickets`,
          method: 'post',
          data: cleanedData
        };
      }
    }),

    exportSupervisorTrackingTickets: builder.mutation<
      Pick<ResponseDto<null>, 'statusCode' | 'message'>,
      ExportExcelSupervisorTrackingTicketDto
    >({
      query: (data) => ({
        url: `/excels/export_supervisor_ticket_tracking_detail_tickets`,
        method: 'post',
        data: data
      })
    })
  })
});

function cleanObject<T extends Record<string, any>>(obj: T): Partial<T> {
  const cleaned: Partial<T> = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      (Array.isArray(value) && value.length === 0) ||
      value === 0
    ) {
      return;
    }
    cleaned[key as keyof T] = value;
  });
  return cleaned;
}


export const { useExportUsersMutation, useExportTicketsMutation, useExportSupervisorTrackingTicketsMutation } =
  excelsApi;
